module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAeCAMAAACyuAbNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0ebd2erizNzVytbQ6fLt6enqyNDL+vv79PT02tzc4eHi1NXVz+La0dHR////3u7pfUBg+wAAAMNJREFUeNrs1EEOhCAMQNG2UCigcP/bDqATiaNi9/N3Jj7SGAt4a63PisCWUqCFvbJl965EeQxgOK0d52fitwxoDNEC8F7wuuWcMw1XPRFxPUcTkbMIM4cQ3oshafpxKjyJHj5+brVArxXFqkVRCwTtr/YXY0SoFHVXDCpFM4bgtRDet+xyuitR89t6OUPLqABvRTUicVd98XEhcqsjuBV9vHTcGu670wGer0zhcFwZKaa5aPPZ+mIKLFIfOEbI2j4CDABYU0vq/pmnnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/OK.png
// module id = cQMU
// module chunks = 1